import { render, staticRenderFns } from "./taskDetail2.vue?vue&type=template&id=5072353f&scoped=true&"
import script from "./taskDetail2.vue?vue&type=script&lang=js&"
export * from "./taskDetail2.vue?vue&type=script&lang=js&"
import style0 from "./taskDetail2.vue?vue&type=style&index=0&id=5072353f&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5072353f",
  null
  
)

export default component.exports